import { render, staticRenderFns } from "./Echarts2.vue?vue&type=template&id=3d6b727c&scoped=true&"
import script from "./Echarts2.vue?vue&type=script&lang=js&"
export * from "./Echarts2.vue?vue&type=script&lang=js&"
import style0 from "./Echarts2.vue?vue&type=style&index=0&id=3d6b727c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6b727c",
  null
  
)

export default component.exports